<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert')">Carl Von Schubert</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/egon-muller')">Egon Müller</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/jj-prum')">J.J. Prüm</nuxt-link>
                    <nuxt-link class="wine-guide-country active" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/peter-lauer')">Peter Lauer</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/van-volxem')">Van Volxem</nuxt-link>
                    <nuxt-link class="wine-guide-country two-line" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken')">Weingut Forstmeister Geltz Zilliken</nuxt-link>
                    <nuxt-link class="wine-guide-country two-line" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch')">Wwe. Dr. H. Thanisch, Erben Thanisch</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Peter Lauer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        È ufficiale: alcuni vini sono dei cult. Non strano, beviamo tutti il ​​tipo di culto del kool aid, di più
                        come una specie di culto underground, stravagante, figo, tipo Twin Peaks. Ovviamente buono, se lo sai
                        cosa cercare, tipo di cosa. Lo splendido e saporito Riesling di Peter Lauer “rinfrescante come
                        bere pura acqua di sorgente” è uno di questi vini.
                    </div>

                    <div class="howto-title2">La Saar del Riesling tedesco</div>
                    <div class="howto-text">
                        Situata nel Santo Graal delle regioni in crescita, la Saar tedesca, Lauer è in buona compagnia. Il suo
                        vicini includono Egon Müller e Hanno Zilliken, ma a differenza dei vini dolci di Muller, quelli di Lauer sembrano
                        per scoppiare di luminosità. Ciò che è simile, tuttavia, sono i tratti distintivi che tendono a sottolineare il
                        regione: rigore, purezza e semplice fatica. La tenuta risale al 1913 ed oggi è gestita da
                        Il nipote di Peter, Florian. È Florian, che ha preso il timone 2005, che è responsabile
                        dando vita ai Riesling della sua famiglia. Né secco né dolce, Florian ha aiutato il suo
                        i vini di famiglia trovano il proprio equilibrio. Il suo tocco moderno è più materico, più profondo e, dicono alcuni,
                        più maschile nel gusto. Tuttavia, questo è bilanciato da un'energia singolare.
                    </div>

                    <div class="howto-title2">Nome, grado e numero di serie</div>
                    <div class="howto-text">
                        Il più comune nelle liste dei vini dei ristoranti è il suo Barrel X entry-level, ed è anche un vino molto raffinato
                        - se vuoi da bere. Tuttavia, per il collezionista esperto, l'attenzione è rivolta ai suoi Grosses asciutti
                        Bottiglie numerate Gewächs Fass. Costoso e raro (due parole d'ordine che piacciono a tutti gli investitori di vino
                        ascolta), vengono prodotti pochissimi casi e ancor meno esportati (solo 20 casi sono arrivati negli Stati Uniti nel
                        2017). Chiamato (scusate, numerato) dopo le botti in cui il vino è stato maturato e il
                        particolare vigneto, questi sono la crema di Lauer del raccolto Reisling. Tuttavia, fai attenzione un po '
                        viene applicata la licenza poetica; “Fass 6 – Senior” si basa su una selezione di frutta che apparteneva a Florian
                        il preferito del nonno. Su questa botte scriveva “Senior”, quindi, oggi, il vino da questo
                        il pacco si chiama "Fass 6 - Senior". La bellezza del vino Fass è, nonostante la sua deliziosa delicatezza
                        e prezzo ragionevole, l'invecchiamento è di oltre un decennio e la carenza di prodotto avrà un ruolo importante
                        spingendo i prezzi verso l'alto.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Con le degustazioni che storicamente si svolgono ad agosto, le quantità si spostano contemporaneamente
                                rapidamente, sebbene sia possibile trovare più valore sul mercato secondario una volta che i punteggi e
                                le quantità vengono rilasciate.
                            </li>
                            <li>Il continuo e affascinante uso dei numeri di Fass da parte di Lauer può essere motivo di confusione oltre il
                                estimatore medio del vino: nel 2018 gli algoritmi di Wine-Searcher hanno richiesto una modifica a
                                individuare la distinzione tra i vini di monovitigno e gli assemblaggi.
                            </li>
                            <li>Nella loro edizione 2009 di "Independent Review of Mosel Riesling" Mosel Fine Wines riporta che sono stati prodotti solo 60 litri di Peter Lauer Ayler Kupp Riesling Trockenbeerenauslese - senza dubbio la scarsità di questo vino dolce molto apprezzato e 96 punti che contribuiscono al suo alto prezzi (che, secondo wine-searcher, superano in media i 600 €, tutte le annate, nel secondo trimestre 2019).
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Peter Lauer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Es ist offiziell: Manche Weine sind Kult. Nicht seltsam, lasst uns alle die Art von Kool-Aid-Kult trinken, mehr noch
                        wie eine Art unterirdischer, schrulliger, cooler Twin-Peaks-Kult. Offensichtlich gut, wenn Sie es wissen
                        worauf man achten sollte, so etwas. Peter Lauers herrlicher, aromatischer Riesling „so erfrischend wie
                        Reines Quellwasser trinken“ ist ein solcher Wein.
                    </div>

                    <div class="howto-title2">Die Saar des deutschen Rieslings</div>
                    <div class="howto-text">
                        Mit seiner Lage im heiligen Gral der Anbauregionen, der deutschen Saar, befindet sich Lauer in guter Gesellschaft. Sein
                        Zu den Nachbarn zählen Egon Müller und Hanno Zilliken, doch im Gegensatz zu Müllers Süßweinen scheinen Lauers Weine zu sein
                        vor Helligkeit knallen. Was jedoch ähnlich ist, sind die Merkmale, die das unterstreichen
                        Region: Strenge, Reinheit und einfache harte Arbeit. Das Anwesen stammt aus dem Jahr 1913 und wird heute von geführt
                        Peters Enkel Florian. Verantwortlich dafür ist Florian, der 2005 das Ruder übernommen hat
                        den Rieslingen seiner Familie Leben einhauchen. Weder trocken noch süß, Florian hat ihm geholfen
                        Der Wein der Familie findet sein eigenes Gleichgewicht. Sein moderner Touch ist strukturierter, tiefer und, wie manche sagen,
                        maskuliner im Geschmack. Dem steht jedoch eine einzigartige Energie gegenüber.
                    </div>

                    <div class="howto-title2">Name, Rang und Seriennummer</div>
                    <div class="howto-text">
                        Am häufigsten auf den Weinkarten von Restaurants steht sein Einstiegswein Barrel X, und er ist auch ein sehr guter Wein
                        - wenn Sie etwas trinken möchten. Für den versierten Sammler richtet sich die Aufmerksamkeit jedoch auf seine trockenen Grosses
                        Gewächs-Fass-nummerierte Flaschen. Teuer und selten (zwei Schlagworte, die jeder Weininvestor gerne verwendet).
                        Hören Sie), es werden nur sehr wenige Kisten hergestellt und noch weniger exportiert (nur 20 Kisten haben es 2011 in die USA geschafft).
                        2017). Benannt (leider nummeriert) nach den Fässern, in denen der Wein reifte, sowie nach dem
                        In einem bestimmten Weinberg handelt es sich um Lauers Elite der Reisling-Ernte. Seien Sie jedoch ein wenig vorsichtig
                        es wird eine poetische Freiheit angewendet; „Fass 6 – Senior“ basiert auf einer Obstauswahl von Florian
                        Großvaters Liebling. Auf dieses Fass würde er „Senior“ schreiben, also heute der Wein daraus
                        Das Paket heißt „Fass 6 – Senior“. Die Schönheit des Fass-Weins ist, trotz seiner schönen Feinheit
                        und angemessener Preis, die Alterung beträgt weit über ein Jahrzehnt und Produktknappheit wird dabei eine Rolle spielen
                        die Preise in die Höhe treiben.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Da die Verkostungen traditionell im August stattfinden, verschieben sich gleichzeitig die Mengen
                                schnell, obwohl auf dem Sekundärmarkt möglicherweise mehr Wert gefunden wird, sobald Punkte erzielt werden und
                                Mengen werden freigegeben.
                            </li>
                            <li>Lauers anhaltende charmante Verwendung von Fass-Zahlen kann darüber hinaus Anlass zu Verwirrung geben
                                durchschnittlicher Weinliebhaber: Im Jahr 2018 erforderten die Algorithmen von Wine-Searcher eine Änderung
                                den Unterschied zwischen Weinen aus Einzellagen und Cuvées erkennen.
                            </li>
                            <li>In der Ausgabe 2009 von „Independent Review of Mosel Riesling“ berichtet Mosel Fine Wines, dass lediglich 60 Liter Peter Lauer Ayler Kupp Riesling Trockenbeerenauslese produziert wurden – zweifellos die Seltenheit dieses hoch angesehenen Süßweins und 96 Punkte, die zu seinem High beitragen Preise (die laut wine-searcher im zweiten Quartal 2019 für alle Jahrgänge durchschnittlich über 600 € lagen).
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Peter Lauer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        C'est officiel : certains vins sont cultes. Pas bizarre, buvons tous le type de culte kool aid, plus
                        comme une sorte de culte underground, décalé, cool, à la Twin Peaks. Évidemment bon, si vous savez
                        ce qu'il faut rechercher, type de chose. Le magnifique et savoureux Riesling de Peter Lauer « aussi rafraîchissant que
                        boire de l'eau de source pure » est l'un de ces vins.
                    </div>

                    <div class="howto-title2">La Sarre du Riesling allemand</div>
                    <div class="howto-text">
                        Situé dans le Saint Graal des régions en croissance - la Sarre allemande - Lauer est en bonne compagnie. Son
                        les voisins incluent Egon Müller et Hanno Zilliken, mais contrairement aux vins doux de Muller, ceux de Lauer semblent
                        éclater avec éclat. Ce qui est similaire cependant, ce sont les caractéristiques qui tendent à souligner le
                        région : rigueur, pureté et travail acharné simple. Le domaine date de 1913 et est aujourd'hui dirigé par
                        Le petit-fils de Peter, Florian. C'est Florian, qui a pris la barre en 2005, qui est responsable de
                        donner vie aux Rieslings de sa famille. Ni sec ni sucré, Florian a aidé son
                        les vins de la famille trouvent leur propre équilibre. Sa touche moderne est plus texturée, plus profonde et, disent certains,
                        goût plus masculin. Cependant, cela est équilibré avec une énergie qui est singulière.

                    </div>

                    <div class="howto-title2">Nom, grade et numéro de série</div>
                    <div class="howto-text">
                        Le baril X d'entrée de gamme est le plus courant sur les listes de vins des restaurants, et c'est aussi un très bon vin.
                        - Si vous voulez boire un verre. Cependant, pour le collectionneur avisé, l'attention est tournée vers ses grosses sèches
                        Bouteilles numérotées Gewächs Fass. Cher et rare (deux mots à la mode que tout investisseur en vin aime
                        entendre), très peu de caisses sont fabriquées, et encore moins exportées (seulement 20 caisses sont arrivées aux États-Unis en
                        2017). Nommé (pardon, numéroté) d'après les fûts dans lesquels le vin a été élevé ainsi que le
                        vignoble particulier, ce sont la crème de Lauer de la récolte Reisling. Attention toutefois un peu
                        la licence poétique est appliquée ; « Fass 6 – Senior » est basé sur une sélection de fruits qui appartenait à Florian
                        le préféré de grand-père. Sur ce tonneau, il écrivait "Senior", donc, aujourd'hui, le vin de ce
                        colis s'appelle "Fass 6 - Senior". La beauté du vin de Fass est, malgré sa belle délicatesse
                        et prix raisonnable, le vieillissement est bien supérieur à une décennie et la pénurie de produit jouera un rôle dans
                        faisant monter les prix.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Les dégustations ayant lieu historiquement en août, les quantités se déplacent simultanément
                                rapidement, bien que plus de valeur puisse être trouvée sur le marché secondaire une fois les scores et
                                quantités sont libérées.
                            </li>
                            <li>L'utilisation charmante et continue de Lauer des nombres Fass peut être source de confusion au-delà du
                                admirateur moyen de vin: en 2018, les algorithmes de Wine-Searcher ont nécessité une modification de
                                identifier la distinction entre les vins de mono-vignoble et les assemblages.
                            </li>
                            <li>Dans leur édition 2009 de "Revue indépendante du Riesling de Moselle", Mosel Fine Wines rapporte que seulement 60 litres de Peter Lauer Ayler Kupp Riesling Trockenbeerenauslese ont été produits - sans aucun doute la rareté de ce vin doux très apprécié et 96 points contribuant à sa haute les prix (qui, selon wine-searcher, dépassent en moyenne les 600 €, tous millésimes confondus, au T2 2019).
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Peter Lauer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        It’s official: some wines are cults. Not weird, let’s all drink the kool aid type of cult, more
                        like a kind of underground, quirky, cool, Twin Peaks type of cult. Obviously good, if you know
                        what to look for, type of thing. Peter Lauer’s gorgeous, flavoursome Riesling “as refreshing as
                        drinking pure spring water” is one such wine.
                    </div>

                    <div class="howto-title2">The Saar of German Riesling</div>
                    <div class="howto-text">
                        Located in the holy grail of growing regions - Germany’s Saar - Lauer is in good company. His
                        neighbours include Egon Müller and Hanno Zilliken, yet unlike Muller’s sweet wines, Lauer’s seem
                        to pop with brightness. What is similar however are the hallmarks which tend to underscore the
                        region: rigour, purity and simple hard work. The estate dates back to 1913 and today is run by
                        Peter’s grandson, Florian. It is Florian, who took the helm 2005, who is responsible for
                        breathing life into his family’s Rieslings. Neither dry nor sweet, Florian has helped his
                        family’s wine find their own balance. His modern touch is more textural, deeper and, some say,
                        more masculine in taste. However, this is balanced with an energy that is singular.

                    </div>

                    <div class="howto-title2">Name, rank and serial number</div>
                    <div class="howto-text">
                        Most common on restaurant wine lists is his entry-level Barrel X, and a very fine wine it is too
                        - if you want a drink. However, for the savvy collector, attention is turned to his dry Grosses
                        Gewächs Fass-numbered bottles. Expensive and rare (two buzzwords every wine investor likes to
                        hear), very few cases are made, and even less exported (just 20-cases made it to the US in
                        2017). Named (sorry, numbered) after the barrels in which the wine was matured as well as the
                        particular vineyard, these are Lauer’s cream of the Reisling crop. However, beware as a little
                        poetic licence is applied; “Fass 6 – Senior” is based on a selection of fruit that was Florian’s
                        grandfather’s favourite. On this barrel, he would write “Senior”, so, today, the wine from this
                        parcel is called “Fass 6 – Senior.” The beauty of the Fass wine is, despite its lovely delicacy
                        and reasonable price, ageing is well over a decade and shortage of product will play a part in
                        pushing prices up.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>With tastings historically taking place in August, quantities simultaneously move
                                quickly, though more value may be found on the secondary market once scores and
                                quantities are released.
                            </li>
                            <li>Lauer’s continued charming use of Fass numbers may be cause for confusion beyond the
                                average admirer of wine: In 2018 Wine-Searcher’s algorithms required an amendment to
                                identify the distinction between the wines of single-vineyards and blends.
                            </li>
                            <li>In their 2009 edition of “Independent Review of Mosel Riesling” Mosel Fine Wines reports a mere 60 litres of Peter Lauer Ayler Kupp Riesling Trockenbeerenauslese was produced - no doubt the scarcity of this highly regarded sweet wine and 96 points contributing to its high prices (which, according to wine-searcher average more than €600, all vintages, in Q2 2019).
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PeterLauer",
    data() {
        return {
            select: {report: 'Peter Lauer', src: '/wine-guide/germany/mosel-saar-ruwer/peter-lauer'},
            items: [
                {report: 'Carl Von Schubert', src: '/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert'},
                {report: 'Egon Müller', src: '/wine-guide/germany/mosel-saar-ruwer/egon-muller'},
                {report: 'J.J. Prüm', src: '/wine-guide/germany/mosel-saar-ruwer/jj-prum'},
                {report: 'Peter Lauer', src: '/wine-guide/germany/mosel-saar-ruwer/peter-lauer'},
                {report: 'Van Volxem', src: '/wine-guide/germany/mosel-saar-ruwer/van-volxem'},
                {
                    report: 'Weingut Forstmeister Geltz Zilliken',
                    src: '/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken'
                },
                {
                    report: 'Wwe. Dr. H. Thanisch, Erben Thanisch',
                    src: '/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Peter Lauer | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wines of Peter Lauer, a renowned wine producer in the Mosel region known for their top-quality Riesling grapes and traditional winemaking techniques. Experience the finesse and balance of Peter Lauer wines with each sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
